// extracted by mini-css-extract-plugin
export var divider = "_wb-0";